import { useAdInsightsCubeMetaQuery } from "src/graphql/types";

export const insightsMetaQuery = {
  queryKey: [...useAdInsightsCubeMetaQuery.getKey(), "nested"],
  queryFn: useAdInsightsCubeMetaQuery.fetcher(undefined, {
    "x-hightouch-insights-nested": "1",
  }),
};
